<template>
  <div class="sub-title d-flex justify-content-between align-items-center">
    <div :class="textClassname">{{subTitle}}</div>
    <div :class="badgeClassName">{{ number }}</div>
  </div>
</template>

<script>
  export default {
    name: 'SubTitle',
    props: ['subTitle', 'number', 'color'],
    computed: {
      badgeClassName() {
        return `sub-title--badge sub-title--badge--${this.color}`
      },
      textClassname() {
        return `sub-title--text sub-title--text--${this.color}`
      }
    }
  }
</script>

<style lang="scss" scoped>
  .sub-title {
    &--text {
      padding-left: 5px;
      font-weight: bold;

      &--pink {
        color: #e51349;
      }

      &--orange {
        color: #ff5500;
      }

      &--purple {
        color: #8f13fd;
      }
    }

    &--badge {
      display: inline-block;
      height: 28px;
      width: 28px;
      line-height: 28px;
      border-radius: 50%;
      color: #FFF;
      text-align: center;
      font-weight: bold;
      font-size: 14px;
      &--pink {
        background-image: linear-gradient(315deg, rgba(255, 67, 207, 1) 0%, rgba(229, 20, 73, 1) 68%);
      }

      &--orange {
        background: linear-gradient(315deg, rgba(239, 164, 42, 1) 0%, rgba(255, 85, 0, 1) 68%);
      }

      &--purple {
        background: linear-gradient(315deg, rgba(165, 150, 255, 1) 0%, rgba(143, 19, 253, 1) 68%);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/manager/SubTitle.vue